/**
 * Format ticket for payin
 * @param params
 * @returns {{bets: Array, payin: number}}
 */
export const formatter = params => {
  let ticket = params.ticket,
    bets = ticket.bets,
    result = { bets: [], payin: 0 },
    isSystem;

  for (let j = 0; j < bets.length; j++) {
    isSystem = bets[j].hasOwnProperty('system') && bets[j].system;

    result.bets.push({
      payin: bets[j].stake ? bets[j].stake : false,
      type: bets[j].id,
      value: bets[j].value,
      numEvents: bets[j].numEvents ? bets[j].numEvents : 1,
    });

    //add system property
    if (isSystem) {
      result.bets[result.bets.length - 1].system = bets[j].system;
    }

    result.payin += bets[j].stake;
  }

  return result;
};



// WEBPACK FOOTER //
// ticketFormatter.js